import { FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query'

import { transformResponseWithPagination } from '@helpers'
import { URLS } from '@constants'
import {
  GETDictionaryByCategoryCode,
  GETDictionaryCategory,
  GetDictionaryData,
  GETObjectDataParams,
} from '@types'

import { commonAPI } from './common.api'

export const dictionaryAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllDictionaries: build.mutation<GetDictionaryData, GETObjectDataParams | void>({
      query: params => ({
        url: URLS.FRONT_CFG + '/dictionary/values',
        params: {
          page: params?.page,
          size: params?.size,
        },
      }),
      transformResponse: (output: GETDictionaryByCategoryCode[], meta: FetchBaseQueryMeta) =>
        transformResponseWithPagination<GETDictionaryByCategoryCode[]>(output, meta),
    }),
    fetchDictionariesByCategoryCode: build.query<
      GETDictionaryByCategoryCode[],
      string | null | void
    >({
      query: catCode => ({
        url: URLS.FRONT_CFG + `/dictionary/values/category/code/${catCode}`,
      }),
    }),
    fetchDictionariesByCategoryCodeForInfiniteScroll: build.mutation<
      GetDictionaryData,
      { categoryId: string }
    >({
      query: ({ categoryId }) => ({
        url: URLS.FRONT_CFG + `/dictionary/values/category/code/${categoryId}`,
      }),
      transformResponse: (output: GETDictionaryByCategoryCode[], meta: FetchBaseQueryMeta) =>
        transformResponseWithPagination<GETDictionaryByCategoryCode[]>(output, meta),
    }),
    fetchAllDictionaryCategories: build.query<GETDictionaryCategory[], void>({
      query: () => ({
        url: URLS.FRONT_CFG + '/dictionary/categories',
      }),
    }),
  }),
})

export const {
  useFetchAllDictionariesMutation,
  useFetchDictionariesByCategoryCodeQuery,
  useFetchDictionariesByCategoryCodeForInfiniteScrollMutation,
  useFetchAllDictionaryCategoriesQuery,
} = dictionaryAPI
